import { css } from '@emotion/core';

export const controls = css`
  .Suggest input {
    box-sizing: border-box;
    width: 100%;
  }
`;

export const techicalIndicators = css`
  label {
    display: block;
    margin-bottom: 15px;
  }

  input[name='interval'] {
    display: block;
    height: 32px;
    box-sizing: border-box;
    width: 100%;
  }
`;

export const Legend = css`
  padding: 0;
`;

export const label = css`
  color: #676767;
  font-size: 16px;
  display: inline-block;
  margin-right: 20px;

  & button {
    padding: 10px 15px 10px 10px;
    position: relative;
  }

  & button:hover,
  & button:focus,
  & button:active {
    cursor: pointer;

    &::after {
      background-color: #676767;
      position: absolute;
      width: 100%;
      left: 0px;
      top: 0px;
      content: attr(title);
      color: white;
      text-align: center;
      border-radius: 4px;
      padding: 10px 2.5px 10px 2.5px;
    }
  }
`;

export const labelCircle = css`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 12px;
  margin-right: 10px;
`;

export const main = css`
  ${label}
`;

export const expandButton = css`
  width: 100%;
  padding: 10px;
  background-color: transparent;
  border: 0;
  cursor: pointer;
`;
